import { FormikProps } from "formik";
import { V3TertiaryButton } from "../Button";
import { V3TertiaryCTAColor } from "../Button/V3TertiaryCTA.types";
import { V3Dropdown } from "../Dropdown";
import { V3IconSort } from "../Icons";
import { V3RadioButton } from "../OptionInput";
import { DEFAULT_ORDER_BY, SEARCH_TERM_DEFAULT_ORDER_BY, SearchContentFormik } from "../../types/content-search";
import { useWindowSize } from "../../hooks/useWindowSize";
import { GeneralContentOrderBy } from "@authory-packages/core";
import { VerticalSpacing } from "../VerticalSpacing";

export const SHORTEN_FILTER_OPTION_BR = 1200;

interface ContentSortProps {
    isActiveTextSearch: boolean;
    searchContentFormik: FormikProps<SearchContentFormik>;
}

export const ContentSort = ({ isActiveTextSearch, searchContentFormik }: ContentSortProps) => {
    const size = useWindowSize();

    return (
        <>
            {isActiveTextSearch && (
                <div>
                    <V3Dropdown
                        renderReferenceElement={() => {
                            return (
                                <V3TertiaryButton
                                    text={
                                        size.width && size.width > SHORTEN_FILTER_OPTION_BR
                                            ? `Sorted by ${searchContentFormik.values.sort === SEARCH_TERM_DEFAULT_ORDER_BY ? "relevance" : "date"}`
                                            : undefined
                                    }
                                    icon={<V3IconSort />}
                                    ctaColor={V3TertiaryCTAColor.gray}
                                />
                            );
                        }}
                        renderPopperElement={(_active, setShowPopper) => (
                            <>
                                <VerticalSpacing bottom={12} top={6}>
                                    <V3RadioButton
                                        name={"relevance"}
                                        id={"sort-relevance"}
                                        label="Sort by relevance"
                                        checked={searchContentFormik.values.sort === SEARCH_TERM_DEFAULT_ORDER_BY}
                                        onChange={() => {
                                            searchContentFormik.setFieldValue("sort", SEARCH_TERM_DEFAULT_ORDER_BY as GeneralContentOrderBy);
                                            searchContentFormik.submitForm();
                                            setShowPopper(false);
                                        }}
                                    />
                                </VerticalSpacing>
                                <VerticalSpacing bottom={6}>
                                    <V3RadioButton
                                        name={"media"}
                                        id={"sort-date"}
                                        label="Sort by date"
                                        checked={searchContentFormik.values.sort === DEFAULT_ORDER_BY}
                                        onChange={() => {
                                            searchContentFormik.setFieldValue("sort", DEFAULT_ORDER_BY as GeneralContentOrderBy);
                                            searchContentFormik.submitForm();
                                            setShowPopper(false);
                                        }}
                                    />
                                </VerticalSpacing>
                            </>
                        )}
                    />
                </div>
            )}
        </>
    );
};
